import Vue from "@/shared/node_modules/vue";

type ClickOutsideEl = HTMLElement & {
  __clickOutsideHandler__?: (event: Event) => void;
};

Vue.directive("click-outside", {
  bind(el: ClickOutsideEl, binding: any) {
    const handler = (event: Event) => {
      const target = event.target as Node | null;
      if (!target) return;
      if (el === target || el.contains(target)) return;
      const value = binding.value;
      if (typeof value === "function") {
        value(event);
        return;
      }
      if (value && typeof value.handler === "function") {
        value.handler(event);
      }
    };
    el.__clickOutsideHandler__ = handler;
    document.addEventListener("click", handler);
    document.addEventListener("touchstart", handler);
  },
  unbind(el: ClickOutsideEl) {
    const handler = el.__clickOutsideHandler__;
    if (!handler) return;
    document.removeEventListener("click", handler);
    document.removeEventListener("touchstart", handler);
    delete el.__clickOutsideHandler__;
  },
});
